(function () {
  const SLIDER_SELECTOR = '[data-shop-by-brand-slider]';

  function initSlider(sliderEl) {
    if (typeof Swiper === 'undefined') return;
    if (sliderEl.dataset.shopByBrandInit === 'true') return;

    let options = {};

    try {
      options = JSON.parse(sliderEl.dataset.sliderOptions || '{}');
    } catch (error) {
      console.warn('Shop by brand slider: options parse error', error);
    }

    sliderEl.dataset.shopByBrandInit = 'true';
    sliderEl.shopByBrandSwiper = new Swiper(sliderEl, options);
  }

  function initAll(root) {
    const scope = root || document;
    scope.querySelectorAll(SLIDER_SELECTOR).forEach(initSlider);
  }

  function destroyAll(root) {
    if (!root) return;

    root.querySelectorAll(SLIDER_SELECTOR).forEach(function (sliderEl) {
      if (sliderEl.shopByBrandSwiper) {
        sliderEl.shopByBrandSwiper.destroy(true, true);
        sliderEl.shopByBrandSwiper = null;
      }

      delete sliderEl.dataset.shopByBrandInit;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target);
  });
})();
